import type { CSSProperties } from 'react';
import { adminButton, adminSurface, adminText, adminTokens as a } from '../admin-ui';

/** Admin recipes shared by the lesson/course and questionnaire republish tabs. */
export const republishStyles: Record<string, CSSProperties> = {
  controls: { display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap', margin: '16px 0' },
  button: { ...adminButton.secondary, minHeight: '34px', fontSize: a.typography.label.size },
  tableFrame: { ...adminSurface.panel, overflowX: 'auto' },
  table: { width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: 14, color: a.text.primary },
  cell: { padding: '12px', borderBottom: `1px solid ${a.border.subtle}`, verticalAlign: 'top' },
  note: { ...adminText.secondary },
  sectionTitle: { ...adminText.sectionTitle, margin: '24px 0 8px' },
  outcome: { ...adminSurface.panel, padding: 12, marginBottom: 8 },
  link: { color: a.text.link, fontWeight: 600 },
};
